import type { IconNode } from '../types';

/**
 * @name square-dashed-x-corner
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgM2gxIiAvPgogIDxwYXRoIGQ9Im0xNiAxNiA1IDUiIC8+CiAgPHBhdGggZD0iTTE5IDNhMiAyIDAgMDEyIDIiIC8+CiAgPHBhdGggZD0ibTIxIDE2LTUgNSIgLz4KICA8cGF0aCBkPSJNMjEgOXYxIiAvPgogIDxwYXRoIGQ9Ik0zIDE0djEiIC8+CiAgPHBhdGggZD0iTTMgOXYxIiAvPgogIDxwYXRoIGQ9Ik01IDIxYTIgMiAwIDAxLTItMiIgLz4KICA8cGF0aCBkPSJNNSAzYTIgMiAwIDAwLTIgMiIgLz4KICA8cGF0aCBkPSJNOSAyMWgxIiAvPgogIDxwYXRoIGQ9Ik05IDNoMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/square-dashed-x-corner
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const SquareDashedXCorner: IconNode = [
  ['path', { d: 'M14 3h1' }],
  ['path', { d: 'm16 16 5 5' }],
  ['path', { d: 'M19 3a2 2 0 012 2' }],
  ['path', { d: 'm21 16-5 5' }],
  ['path', { d: 'M21 9v1' }],
  ['path', { d: 'M3 14v1' }],
  ['path', { d: 'M3 9v1' }],
  ['path', { d: 'M5 21a2 2 0 01-2-2' }],
  ['path', { d: 'M5 3a2 2 0 00-2 2' }],
  ['path', { d: 'M9 21h1' }],
  ['path', { d: 'M9 3h1' }],
];

export default SquareDashedXCorner;
